import { createUseStyles } from 'react-jss';
export const useStyles = createUseStyles((theme) => ({
    wrapper: {
        position: 'absolute',
        bottom: '0px',
        width: '100%',
        backgroundColor: theme.colors.cloud,
    },
}), { name: 'footer-wrapper' });
